module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/latina.e4f6641248673addcb18a04d0e698c03.jpg";